import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import useJobFunctions from '../../../../../../hooks/useJobFunctions';

export const useJobFunctionFilter = ({ setFilters, value }) => {
  const [jobFunctions] = useJobFunctions();

  const jobFunctionOptions = useMemo(() => [{ value: 'any', label: 'Any' }, ...jobFunctions], [jobFunctions]);

  const formSchema = Yup.object().shape({
    jobFunctionOption: Yup.object().shape({
      label: Yup.string().required(),
      value: Yup.string().required(),
    }),
  });

  const onSubmit = ({ jobFunctionOption }) => {
    const jobFunctionValue = jobFunctionOption.value || 'any';
    setFilters(
      { jobFunctionId: jobFunctionValue === 'any' ? null : jobFunctionValue },
      {
        removeFilters: jobFunctionValue === 'any' ? ['jobFunctionId'] : [],
      },
    );
  };

  const selected = useMemo(() => {
    if (!value || value === 'any') {
      return { label: 'Any', value: 'any' };
    }
    const found = jobFunctionOptions.find((i) => i.value.toString() === value?.toString());
    return found || { label: 'Any', value: 'any' };
  }, [value, jobFunctionOptions]);

  return {
    formSchema,
    onSubmit,
    jobFunctionOptions,
    selected,
  };
};

useJobFunctionFilter.propTypes = {
  setFilters: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
